// src/pages/locations/components/FlashBanner.tsx
import React from "react";
import { FiCheckCircle, FiX } from "react-icons/fi";

/**
 * Confirmation of the save that just happened, shown once on the list the user
 * is returned to. Dismissable, and auto-clears so it never lingers.
 */
export const FlashBanner: React.FC<{ message: string | null }> = ({ message }) => {
  const [visible, setVisible] = React.useState(Boolean(message));

  React.useEffect(() => {
    setVisible(Boolean(message));
    if (!message) return;

    const timer = window.setTimeout(() => setVisible(false), 6000);
    return () => window.clearTimeout(timer);
  }, [message]);

  if (!message || !visible) return null;

  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2.5 text-sm text-emerald-800"
    >
      <FiCheckCircle className="mt-0.5 shrink-0" />
      <span className="flex-1">{message}</span>
      <button
        type="button"
        onClick={() => setVisible(false)}
        aria-label="Dismiss"
        className="rounded p-0.5 text-emerald-700 hover:bg-emerald-100"
      >
        <FiX />
      </button>
    </div>
  );
};
